import CreateWorkspacePartial from "../../partials/workspace/create-workspace.partial";

export default function CreateWorkspaceScreen() {
  return <CreateWorkspacePartial />;
}
